// check if the current page is in an iframe
export const isInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
}

// Cache the result to avoid re-parsing on every call
let embedModeCache = null;

// check if the current page should be in embed mode (iframe or embed parameter)
export const isEmbedMode = () => {
    // If we already checked, return cached result
    if (embedModeCache !== null) {
        return embedModeCache;
    }

    // Check if in iframe first (fastest check)
    if (isInIframe()) {
        embedModeCache = true;
        return true;
    }

    // Check for embed parameter in URL
    try {
        // Use window.location.search directly for immediate access
        if (typeof window !== 'undefined' && window.location && window.location.search) {
            // Quick string check first for better performance
            if (window.location.search.includes('embed=true')) {
                // Verify with URLSearchParams for accuracy
                const urlParams = new URLSearchParams(window.location.search);
                embedModeCache = urlParams.get('embed') === 'true';
                return embedModeCache;
            }
        }
        embedModeCache = false;
        return false;
    } catch (e) {
        embedModeCache = false;
        return false;
    }
}